import { createFileRoute } from "@tanstack/react-router";
import SeniorDepressionTreatment from "@/pages/SeniorDepressionTreatment";
import {
  SITE_URL,
  buildBreadcrumbList,
  buildMedicalWebPage,
} from "@/components/schemaConstants";

const PAGE_URL = `${SITE_URL}/senior-depression-treatment`;
const BREADCRUMB_ID = `${PAGE_URL}#breadcrumb`;

export const Route = createFileRoute("/senior-depression-treatment")({
  head: () => ({
    meta: [
      {
        title:
          "Depression Treatment for Seniors & Older Adults in Coral Springs, FL | Medicare Accepted",
      },
      {
        name: "description",
        content:
          "Outpatient depression care for adults 65+ in Coral Springs: TMS, SPRAVATO®, therapy and medication management. In-network with Medicare. Free consultation.",
      },
      {
        property: "og:title",
        content:
          "Depression Treatment for Seniors & Older Adults in Coral Springs, FL",
      },
      {
        property: "og:description",
        content:
          "Outpatient depression care for adults 65+ in Coral Springs. In-network with Medicare. Free consultation.",
      },
      { property: "og:url", content: PAGE_URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: PAGE_URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildMedicalWebPage({
            name: "Depression Treatment for Seniors and Older Adults in Coral Springs, FL",
            description:
              "Outpatient depression care for adults 65+ in Coral Springs: TMS, SPRAVATO®, therapy and medication management. In-network with Medicare.",
            url: PAGE_URL,
            id: `${PAGE_URL}#webpage`,
            breadcrumbId: BREADCRUMB_ID,
          }),
        ),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify(
          buildBreadcrumbList(
            [
              { name: "Home", href: "/" },
              {
                name: "Depression Treatment",
                href: "/depression-treatment-coral-springs",
              },
              {
                name: "Seniors & Older Adults",
                href: "/senior-depression-treatment",
              },
            ],
            BREADCRUMB_ID,
          ),
        ),
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <SeniorDepressionTreatment />;
}
